module.exports = __webpack_public_path__ + "static/media/E_SDG_Icons-13.cb5c619d.jpg";